module.exports = __webpack_public_path__ + "img/m-hd.5be01ed0.jpg";